/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Table, Thead, Tr, Th, Sortable } from "@lightspeed/cirrus-table";
import { Card } from "@lightspeed/flame/Card";
import { Button } from "@lightspeed/flame/Button";
import { FaCog } from "react-icons/fa";
import Row from "./categoriesTableDeferred/Row";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { serverUrl } from "../../serverUrl";
import * as databaseActions from "../../redux/actions/databaseActions";
import * as sortFns from "../../utils/sortFn";
import ClassDepLocInfo from "./ClassDepLocInfo";
import { normalizeQuickBooksAccountList, normalizeQuickBooksClassDepartmentList } from "../../utils/quickbooksClassDepartment";
import { isAcombagoIntegration } from "../../utils/d365Dimensions";

const CategoriesTable = ({ data, sortState, changeSortState, scrollPos }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const showHiddenFields = ui.showHiddenFields;
  const database = useSelector((state) => state.database);
  const userState = useSelector((state) => state.userState);

  const [sortedData, setSortedData] = useState([...data]);
  const [accountsList, setAccountsList] = useState([]);
  const [classList, setClassList] = useState({ classes: [], departments: [] });
  const [customersList, setcustomerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showParentSettings, setShowParentSettings] = useState(false);
  const parentUpdateMode = "all";
  const [parentSettingsSaving, setParentSettingsSaving] = useState(false);
  const [parentSettingsError, setParentSettingsError] = useState("");
  const quickBooksDropShopId =
    database.currentCompany?.type === "RESTOK"
      ? database.currentShop?.area_id ?? database.currentShop?.shop_id ?? 0
      : database.currentShop?.shop_id ?? 0;

  const parentUpdateFields = [
    { key: "account", label: "Account" },
    { key: "account_description", label: "Account Description" },
    { key: "class_department_location", label: "Class/Dep/Loc" },
    { key: "customer", label: "Customer" },
    { key: "cogs", label: "Cogs" },
    { key: "cogs_description", label: "Cogs Desc" },
    { key: "cogs_total", label: "Cogs (Total)" },
    { key: "cogs_description_total", label: "Cogs Desc (Total)" },
  ];

  const [selectedParentUpdateFields, setSelectedParentUpdateFields] = useState(
    parentUpdateFields.map((field) => field.key)
  );

  const sortValues = ["unsorted", "desc", "asc"];
  const reducer = (acc, cur) => acc + cur;
  const acombagoIntegration = isAcombagoIntegration(database.currentCompany, database.currentShop);

  const COL = {
    COMPANY: 0,
    CATEGORY_ID: 1,
    CATEGORY_NAME: 2,
    PARENT: 3,
    ACCOUNT: 4,
    ACCOUNT_DESC: 5,
    CDL: 6,
    CUSTOMER: 7,
    FLASH: 8,
    COGS: 9,
    COGS_DESC: 10,
    COGS_TOTAL: 11,
    COGS_DESC_TOTAL: 12,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [accRes, classRes, customerRes] = await Promise.all([
          fetch("https://reportapi.beesql.com/api/admin/retailr/report", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              company_id: database.currentCompany.id,
              shop_id: quickBooksDropShopId,
              xoption: "QuickBooksIMPORT DROP_ACCOUNT_LIST",
            }),
          }),
          fetch("https://reportapi.beesql.com/api/admin/retailr/report", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              company_id: database.currentCompany.id,
              shop_id: quickBooksDropShopId,
              xoption: "QuickBooksIMPORT DROP_CLASSDEPARTMENT",
            }),
          }),
          fetch("https://reportapi.beesql.com/api/admin/retailr/report", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              company_id: database.currentCompany.id,
              shop_id: quickBooksDropShopId,
              xoption: "QuickBooksIMPORT DROP_CUSTOMER_LIST",
            }),
          }),
        ]);

        const accountsData = await accRes.json();
        const classDataRaw = await classRes.json();
        const customerDataRaw = await customerRes.json();

        setAccountsList(normalizeQuickBooksAccountList(accountsData));
        setcustomerList(Array.isArray(customerDataRaw) ? customerDataRaw : []);


        const cleanedClassList = normalizeQuickBooksClassDepartmentList(classDataRaw);


        setClassList(cleanedClassList);
        setLoading(false);
      } catch (err) {
        console.error("Greška pri fetchanju konta/klasa:", err);
        setLoading(false);
      }
    };

    if (database?.currentCompany?.id && quickBooksDropShopId) {
      fetchData();
    }
  }, [database.currentCompany.id, quickBooksDropShopId]);

  useEffect(() => {
    setSortedData([...data]);
  }, [data]);

  useEffect(() => {
    if (sortState.reduce(reducer) > 0) {
      if (sortState[COL.COMPANY] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("company_id"))]);
      } else if (sortState[COL.COMPANY] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("company_id")).reverse()]);
      }

      if (sortState[COL.CATEGORY_ID] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("category_id"))]);
      } else if (sortState[COL.CATEGORY_ID] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("category_id")).reverse()]);
      }

      if (sortState[COL.CATEGORY_NAME] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("category_name"))]);
      } else if (sortState[COL.CATEGORY_NAME] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("category_name")).reverse()]);
      }

      if (sortState[COL.PARENT] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("parentid"))]);
      } else if (sortState[COL.PARENT] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("parentid")).reverse()]);
      }

      if (sortState[COL.ACCOUNT] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("account_id"))]);
      } else if (sortState[COL.ACCOUNT] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("account_id")).reverse()]);
      }

      if (sortState[COL.ACCOUNT_DESC] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("account_description"))]);
      } else if (sortState[COL.ACCOUNT_DESC] === 2) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("account_description")).reverse(),
        ]);
      }

      if (sortState[COL.CDL] === 1) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("class_department_location")),
        ]);
      } else if (sortState[COL.CDL] === 2) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("class_department_location")).reverse(),
        ]);
      }

      if (sortState[COL.CUSTOMER] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("qb_customer_id"))]);
      } else if (sortState[COL.CUSTOMER] === 2) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("qb_customer_id")).reverse(),
        ]);
      }

      if (sortState[COL.FLASH] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("flash"))]);
      } else if (sortState[COL.FLASH] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGen("flash")).reverse()]);
      }

      if (sortState[COL.COGS] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("cogs"))]);
      } else if (sortState[COL.COGS] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("cogs")).reverse()]);
      }

      if (sortState[COL.COGS_DESC] === 1) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("cogs_description")),
        ]);
      } else if (sortState[COL.COGS_DESC] === 2) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("cogs_description")).reverse(),
        ]);
      }

      if (sortState[COL.COGS_TOTAL] === 1) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("cogs2"))]);
      } else if (sortState[COL.COGS_TOTAL] === 2) {
        setSortedData((old) => [...old.sort(sortFns.customSortGenString("cogs2")).reverse()]);
      }

      if (sortState[COL.COGS_DESC_TOTAL] === 1) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("cogs_description2")),
        ]);
      } else if (sortState[COL.COGS_DESC_TOTAL] === 2) {
        setSortedData((old) => [
          ...old.sort(sortFns.customSortGenString("cogs_description2")).reverse(),
        ]);
      }
    } else {
      setSortedData([...data]);
    }
  }, [sortState, data, database.currentCompany.type]);

  if (sortedData.length === 0 && ui.search) {
    return (
      <div className="loader-no-item">
        <h3>No items match your search</h3>
      </div>
    );
  }

  if (!sortedData || sortedData.length === 0 || !Array.isArray(sortedData) || loading) {
    return <Loader />;
  }

  const retailHasParent = database.currentCompany.type === "RETAIL";
  const accountingColsCount =
    (retailHasParent ? 1 : 0) +
    1 + // Account
    1 + // Account Description
    1 + // Class/Dep/Loc
    (acombagoIntegration ? 0 : 1) + // Customer
    (showHiddenFields ? 5 : 0) +
    1; // Action

  const openParentSettings = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setParentSettingsError("");
    setShowParentSettings(true);
  };

  const handleSaveParentSettings = async () => {
    try {
      setParentSettingsSaving(true);
      setParentSettingsError("");

      const response = await fetch(`${serverUrl}/api/retail/categoriesupdate`, {
        method: "put",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token_user_id: userState?.user?.user_id,
          token_company_id: database.currentCompany.id,
          token_shop_id: database.currentShop.shop_id,
          token_category_id: "parent_option",
          token_account_id: parentUpdateMode,
          token_account_name: JSON.stringify(selectedParentUpdateFields),
          token_flash: null,
          token_cogs: null,
          token_cogs_description: null,
          token_cogs2: null,
          token_cogs_description2: null,
          token_class_department_location: null,
          qb_customer_id: null,
        }),
      });

      const responseText = await response.text();

      if (!response.ok) {
        throw new Error(responseText || `API error ${response.status}`);
      }

      dispatch(
        databaseActions.getShopCategoriesDeferred(
          database.currentCompany.id,
          userState?.user?.user_id,
          database.currentShop.shop_id
        )
      );
      setShowParentSettings(false);
    } catch (error) {
      setParentSettingsError(error.message || "Unable to update child mappings.");
    } finally {
      setParentSettingsSaving(false);
    }
  };

  const renderParentHeader = () => (
    <span className="parent-header-settings">
      Parent
      <button
        type="button"
        className="parent-header-settings-button"
        onClick={openParentSettings}
        title="Parent settings"
        aria-label="Parent settings"
      >
        <FaCog />
      </button>
    </span>
  );

  return (
    <Card top="true">
      <div className="category-table-shell">
        <div className={`payment-table-wrap category-table-wrap ${showHiddenFields ? "show-hidden-fields" : ""}`}>
          <Table>
          <Thead>
            <Tr className={`section-row ${ui.theme === "flame" ? "" : "dark-table-section"}`}>
              <Th colSpan="3" className="section-title section-title-pos">
                <div className="section-badge">POS</div>
              </Th>
              <Th colSpan={accountingColsCount} className="section-title section-title-acc">
                <div className="section-badge">Accounting</div>
              </Th>
            </Tr>

            {scrollPos === true ? (
              <Tr className={`${ui.theme === "flame" ? "" : "dark-table"}`}>
                <Sortable.Th
                  direction={sortValues[sortState[COL.COMPANY]]}
                  onClick={() => changeSortState(COL.COMPANY)}
                  className="th-pos"
                >
                  Company
                </Sortable.Th>

                <Sortable.Th
                  direction={sortValues[sortState[COL.CATEGORY_ID]]}
                  onClick={() => changeSortState(COL.CATEGORY_ID)}
                  className="th-pos"
                >
                  Category Id
                </Sortable.Th>

                <Sortable.Th
                  direction={sortValues[sortState[COL.CATEGORY_NAME]]}
                  onClick={() => changeSortState(COL.CATEGORY_NAME)}
                  className="th-pos th-pos-last"
                >
                  Category Name
                </Sortable.Th>

                {retailHasParent && (
                  <Sortable.Th
                    direction={sortValues[sortState[COL.PARENT]]}
                    onClick={() => changeSortState(COL.PARENT)}
                    className="th-acc th-acc-first"
                  >
                    {renderParentHeader()}
                  </Sortable.Th>
                )}

                <Sortable.Th
                  direction={sortValues[sortState[COL.ACCOUNT]]}
                  onClick={() => changeSortState(COL.ACCOUNT)}
                  className={retailHasParent ? "th-acc" : "th-acc th-acc-first"}
                >
                  Account
                </Sortable.Th>

                <Sortable.Th
                  direction={sortValues[sortState[COL.ACCOUNT_DESC]]}
                  onClick={() => changeSortState(COL.ACCOUNT_DESC)}
                  className="th-acc"
                >
                  Account Description
                </Sortable.Th>

                {!acombagoIntegration && (


                  <Sortable.Th
                  width="5%"
                  direction={sortValues[sortState[COL.CDL]]}
                  onClick={() => changeSortState(COL.CDL)}
                  className="th-acc"
                >
                  Class/Dep/Loc <ClassDepLocInfo />
                </Sortable.Th>


                )}
                <Sortable.Th
                  width="10%"
                  direction={sortValues[sortState[COL.CUSTOMER]]}
                  onClick={() => changeSortState(COL.CUSTOMER)}
                  className="th-acc"
                >
                  {acombagoIntegration ? "Project" : "Customer"}
                </Sortable.Th>

                {showHiddenFields && (
                  <>
                    <Sortable.Th
                      direction={sortValues[sortState[COL.FLASH]]}
                      onClick={() => changeSortState(COL.FLASH)}
                      className="th-acc"
                    >
                      Flash (Yes/No)
                    </Sortable.Th>

                    <Sortable.Th
                      direction={sortValues[sortState[COL.COGS]]}
                      onClick={() => changeSortState(COL.COGS)}
                      className="th-acc"
                    >
                      Cogs
                    </Sortable.Th>

                    <Sortable.Th
                      direction={sortValues[sortState[COL.COGS_DESC]]}
                      onClick={() => changeSortState(COL.COGS_DESC)}
                      className="th-acc"
                    >
                      Cogs Desc
                    </Sortable.Th>

                    <Sortable.Th
                      direction={sortValues[sortState[COL.COGS_TOTAL]]}
                      onClick={() => changeSortState(COL.COGS_TOTAL)}
                      className="th-acc"
                    >
                      Cogs (Total)
                    </Sortable.Th>

                    <Sortable.Th
                      direction={sortValues[sortState[COL.COGS_DESC_TOTAL]]}
                      onClick={() => changeSortState(COL.COGS_DESC_TOTAL)}
                      className="th-acc"
                    >
                      Cogs Desc (Total)
                    </Sortable.Th>
                  </>
                )}

                <Th textAlign="right" className="th-acc th-plain th-action">
                  Action
                </Th>
              </Tr>
            ) : (
              <Tr className={`${ui.theme === "flame" ? "" : "dark-table-fake"}`}>
                <Th className="table-th-sticky th-pos">Company</Th>
                <Th className="table-th-sticky th-pos">Category Id</Th>
                <Th className="table-th-sticky th-pos th-pos-last">Category Name</Th>

                {retailHasParent && (
                  <Th className="table-th-sticky th-acc th-acc-first">
                    {renderParentHeader()}
                  </Th>
                )}

                <Th
                  className={`table-th-sticky th-acc ${retailHasParent ? "" : "th-acc-first"}`}
                >
                  Account
                </Th>

                <Th className="table-th-sticky th-acc">Account Description</Th>
                {!acombagoIntegration && (

                  <Th className="table-th-sticky th-acc">Class/Dep/Loc <ClassDepLocInfo /></Th>

                )}
                <Th className="table-th-sticky th-acc">{acombagoIntegration ? "Project" : "Customer"}</Th>

                {showHiddenFields && (
                  <>
                    <Th className="table-th-sticky th-acc">Flash (Yes/No)</Th>
                    <Th className="table-th-sticky th-acc">Cogs</Th>
                    <Th className="table-th-sticky th-acc">Cogs Desc</Th>
                    <Th className="table-th-sticky th-acc">Cogs (Total)</Th>
                    <Th className="table-th-sticky th-acc">Cogs Desc (Total)</Th>
                  </>
                )}

                <Th className="table-th-sticky th-acc th-plain th-action" textAlign="right">
                  Action
                </Th>
              </Tr>
            )}
          </Thead>

          <tbody className="t-body">
            {sortedData.map((item) => (
              <Row
                key={item.category_id}
                item={item}
                retail={retailHasParent}
                accountsList={accountsList}
                classList={classList}
                customersList={customersList}
                showHiddenFields={showHiddenFields}
                  hideClassDepartmentColumn={acombagoIntegration || isAcombagoIntegration(item)}
              />
            ))}
          </tbody>
          </Table>
        </div>
      </div>
      {showParentSettings && (
        <div
          onClick={() => !parentSettingsSaving && setShowParentSettings(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 640,
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                Parent Settings
              </div>
              <button
                type="button"
                onClick={() => !parentSettingsSaving && setShowParentSettings(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 20,
                  cursor: "pointer",
                  color: "#64748b",
                }}
              >
                &times;
              </button>
            </div>

            <div style={{ padding: 20, color: "#1e293b", lineHeight: 1.6, fontSize: 14 }}>
              <div>
                Update all child categories with values inherited from the main parent category,
                including rows that are already mapped.
              </div>

            <div style={{ marginTop: 18, marginBottom: 10, fontWeight: 600 }}>
              Fields to update:
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                gap: "8px 14px",
              }}
            >
              {parentUpdateFields.map((field) => (
                <label key={field.key} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={selectedParentUpdateFields.includes(field.key)}
                    onChange={(event) => {
                      const isChecked = event.target.checked;
                      setSelectedParentUpdateFields((currentFields) =>
                        isChecked
                          ? [...currentFields, field.key]
                          : currentFields.filter((currentField) => currentField !== field.key)
                      );
                    }}
                  />
                  {field.label}
                </label>
              ))}
            </div>
            {parentSettingsError && (
              <div style={{ marginTop: 14, color: "#b91c1c", fontWeight: 600 }}>
                {parentSettingsError}
              </div>
            )}
            </div>

            <div
              style={{
                padding: "16px 20px",
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
              }}
            >
              <Button
                size="small"
                variant="secondary"
                disabled={parentSettingsSaving}
                onClick={() => setShowParentSettings(false)}
              >
                Close
              </Button>
              <Button
                size="small"
                fill="true"
                disabled={parentSettingsSaving}
                onClick={handleSaveParentSettings}
              >
                {parentSettingsSaving ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};

export default CategoriesTable;
